import { createContext } from 'react'

const returnContext = createContext()

export default returnContext
